import { Injectable } from "@angular/core";
import { AlertController, ToastController } from "ionic-angular";
import { User } from "./user";

@Injectable()
export class WeixinQr {
  constructor(
    private toastCtrl: ToastController,
    private alertCtrl: AlertController,
    public user: User
  ) {}

  show(url, title) {
    if (!url || !url.trim()) {
      return Promise.resolve();
    }
    const listener = () => {
      this.alertCtrl
        .create({
          title: "无法加入微信群",
          message: "如遇微信群二维码失效，<br/>请加微信 13816983316",
        })
        .present();
    };

    return new Promise((resolve, reject) => {
      let setUnusableHintOnClick = () => {
        for (let element of Array.from(
          document.body.getElementsByClassName("weixin-qr-unusable-hint")
        )) {
          element.removeEventListener("click", listener);
          element.addEventListener("click", listener);
        }
      };
      setUnusableHintOnClick();
      setTimeout(setUnusableHintOnClick, 500);
      setTimeout(setUnusableHintOnClick, 2000);
      this.alertCtrl
        .create({
          cssClass: "weixin-qr-alert",
          title: title,
          message: `<div>
<div>
    请使用微信扫码入群，加入学习讨论
</div>
<div>
</div>
<a class="visible-qq" style="margin-top: 10px;">使用QQ平台的用户，<br>请长按保存二维码到相册后，<br>使用微信扫一扫从相册扫码后加入</a>
<img src='${url}'/>
<a class="weixin-qr-unusable-hint">无法加入微信群？</a>
</div>`,
          subTitle: ``,
          buttons: [
            {
              text: "完成",
              cssClass: "font-weight-normal",
              role: "cancel",
              handler: () => {
                resolve(false);
              },
            },
          ],
        })
        .present();
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/weixin_qr.ts